<template>
  <div class="page-home">
    <div class="home-left"
         ref="homeLeft">
      <!--轮播图 -->
      <BannerCard ref="bannerCard"
                  :height="bannerHeight" />
      <NoticeList />
      <!--常用模块 -->
      <CommonMenuCard />
    </div>
    <div class="home-right"
         ref="homeRight">
      <!--员工关怀卡片 -->
      <NoticeCard @refresh="handleRefresh" />
      <MyWorkbench ref="myWorkbench" />
      <!--申请卡片 -->
      <!-- <WorkFlow ref="workFlow" /> -->
    </div>
  </div>
</template>

<script>
  // 员工关怀卡片
  import NoticeCard from './notice'
  // 常用模块
  import CommonMenuCard from './common-menu-card'
  // 轮播图
  import BannerCard from './banner'
  import NoticeList from './home-notice/notice-list.vue'
  import MyWorkbench from './my-workbench'
  export default {
    name: 'home',
    components: {
      NoticeCard,
      CommonMenuCard,
      BannerCard,
      NoticeList,
      MyWorkbench
    },
    data () {
      return {
        height: 770,
        bannerHeight: 176 // 轮播图高度，需要动态计算来保证图片的展示
      }
    },
    mounted () {
      this.$bus.$on('SWITCH_MENU', this.handleSwitchMenu)
      this.handleResize()
      this.addResize()
    },
    activated () {
      this.handleResize()
    },
    beforeDestroy () {
      this.$bus.$off('SWITCH_MENU', this.handleSwitchMenu)
    },
    methods: {
      handleSwitchMenu () {
        this.handleResize()
      },
      addResize () {
        window.onresize = this.handleResize
      },
      handleResize () {
        this.$nextTick(() => {
          this.height = this.$refs.homeRight ? this.$refs.homeRight.offsetHeight : 770
          const bannerHeight = this.$refs.homeLeft ? (this.$refs.homeLeft.offsetWidth - 9) * (176 / 760) : 176
          this.bannerHeight = bannerHeight
        })
      },
      /**
       * 刷新数据
       */
      handleRefresh() {
        this.$refs.myWorkbench.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-home {
    // background: var(--g-theme-content-bg);
    display: flex;
    height: 100%;
    margin: 0px;
    min-height: 100%;
    overflow-x: hidden;
    padding: 12px;
    .home-left {
      padding-right: 12px;
      display: flex;
      flex-direction: column;
      box-sizing: content-box;
      min-width: 760px;
      flex: 1;
    }
    .home-right {
      width: 484px;
      // margin-bottom: 12px;
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/index.vue